import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Gallery from './components/Gallery';
import Album from './components/Album';
import SignIn from './components/SignIn';
import Upload from './components/Upload';
import Navigation from './components/Navigation';
import { auth } from './firebaseConfig';
import 'react-image-gallery/styles/css/image-gallery.css';
import { ThemeProvider, createTheme } from '@mui/material';
import FieldGuide from './components/FieldGuide';
import { getUserRole, Permissions, hasPermission, UserRoles } from './services/authService';
import { dbRef, get } from './firebaseConfig';
import { database } from './firebaseConfig';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import AdminDashboard from './components/admin/AdminDashboard';

const theme = createTheme({
    palette: {
        primary: {
            main: '#3498db',
            light: '#5dade2',
            dark: '#2980b9'
        },
        error: {
            main: '#e74c3c',
            light: '#eb6b5d',
            dark: '#c0392b'
        },
        background: {
            default: '#f5f6fa',
            paper: '#ffffff'
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h6: {
            fontWeight: 500
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#fff'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: 'none'
                }
            }
        }
    }
});

const App = () => {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('newest');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const role = await getUserRole(user.uid);
        console.log('User signed in:', user);
        console.log('Retrieved role:', role);
        setUser(user);
        setUserRole(role);
      } else {
        console.log('No user signed in');
        setUser(null);
        setUserRole(UserRoles.GUEST);
      }
    });

    return () => unsubscribe();
  }, []);

  console.log('User:', user);
  console.log('User Role:', userRole);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <Navigation 
            user={user}
            userRole={userRole}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            filter={filter}
            setFilter={setFilter}
          />
          <Routes>
            <Route path="/" element={
              <Gallery 
                searchTerm={searchTerm} 
                filter={filter}
                user={user}
                userRole={userRole}
              />
            } />
            <Route path="/album/:albumId" element={
              <Album 
                user={user}
                userRole={userRole}
              />
            } />
            <Route path="/field-guide" element={
              <FieldGuide 
                  user={user}
                  userRole={userRole}
              />
            } />
            <Route path="/signin" element={<SignIn setUser={setUser} />} />
            
            {/* Protected Routes */}
            <Route path="/upload" element={
              <ProtectedRoute requiredPermission={Permissions.CREATE_ALBUM}>
                <Upload user={user} userRole={userRole} />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute requiredPermission="ADMIN_ACCESS">
                <AdminDashboard user={user} userRole={userRole} />
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;


